var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a-modal",
    {
      attrs: {
        width: 1240,
        cancelText: "false",
        dialogClass: "information-up-wrapper_modal",
        centered: "",
        footer: false,
      },
      on: {
        ok: function ($event) {
          _vm.visible = false
        },
      },
      model: {
        value: _vm.seeVisible,
        callback: function ($$v) {
          _vm.seeVisible = $$v
        },
        expression: "seeVisible",
      },
    },
    [
      _c(
        "a-tabs",
        {
          on: { change: _vm.handleChange },
          model: {
            value: _vm.contentType,
            callback: function ($$v) {
              _vm.contentType = $$v
            },
            expression: "contentType",
          },
        },
        _vm._l(_vm.tabOptions, function (item) {
          return _c("a-tab-pane", {
            key: item.value,
            attrs: { tab: item.label },
          })
        }),
        1
      ),
      _vm.currentContent.length
        ? _c("div", { staticClass: "container-wrapper" }, [
            _vm.contentType !== 7
              ? _c(
                  "div",
                  { staticClass: "left-wrapper" },
                  [
                    _c("div", { staticStyle: { "margin-bottom": "20px" } }, [
                      _c("img", {
                        staticStyle: { width: "100px", height: "23px" },
                        attrs: { src: _vm.noticeLog },
                      }),
                    ]),
                    _c("div", { staticClass: "announcement-title" }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.currentContent[_vm.announcementIndex]
                              .announcementTitle
                          ) +
                          " "
                      ),
                    ]),
                    _vm.currentContent[_vm.announcementIndex].announcementOnTime
                      ? _c(
                          "div",
                          {
                            staticStyle: {
                              color: "#a9adb4",
                              "font-size": "12px",
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm
                                    .moment(
                                      _vm.currentContent[_vm.announcementIndex]
                                        .announcementOnTime
                                    )
                                    .format("YYYY-MM-DD hh:mm:ss")
                                ) +
                                " "
                            ),
                          ]
                        )
                      : _vm._e(),
                    _c(
                      "a-menu",
                      {
                        staticClass: "menu-wrapper",
                        attrs: {
                          defaultSelectedKeys: [_vm.currentMenu],
                          mode: "vertical",
                        },
                      },
                      _vm._l(_vm.contentTitles, function (item, index) {
                        return _c(
                          "a-menu-item",
                          {
                            key: `${item}_${index}`,
                            on: {
                              click: function ($event) {
                                return _vm.handleChangeMenu(item, index)
                              },
                            },
                          },
                          [
                            _c("span", [
                              _c("span", { staticClass: "pointer-container" }),
                              _c("span", {
                                staticClass: "menu-title-name",
                                domProps: { innerHTML: _vm._s(item) },
                              }),
                            ]),
                          ]
                        )
                      }),
                      1
                    ),
                    _c("div", [
                      _c(
                        "a",
                        {
                          staticStyle: {
                            position: "absolute",
                            bottom: "0",
                            height: "32px",
                            color: "#1e5af9",
                            "font-size": "12px",
                          },
                          on: { click: _vm.informationClick },
                        },
                        [
                          _vm._v(
                            " " + _vm._s(_vm.$t("common_btn_know_more")) + " "
                          ),
                        ]
                      ),
                      _vm.announcementIndex < _vm.currentContent.length - 1
                        ? _c(
                            "a",
                            {
                              staticStyle: {
                                position: "absolute",
                                bottom: "0",
                                height: "32px",
                                color: "#1e5af9",
                                "font-size": "12px",
                                right: "40px",
                              },
                              attrs: { loading: _vm.isLoading },
                              on: { click: _vm.nextClick },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t("common_btn_next_tiao", [
                                      _vm.$t("common_home_announcement", []),
                                    ])
                                  ) +
                                  " "
                              ),
                            ]
                          )
                        : _vm._e(),
                    ]),
                  ],
                  1
                )
              : _vm._e(),
            _c("div", { staticClass: "content-wrapper" }, [
              _vm.currentContent.length
                ? _c(
                    "div",
                    {
                      ref: "information",
                      staticClass: "information mce-content-body",
                      style: {
                        "padding-right":
                          _vm.contentType !== 7 ? "190px" : "0px",
                      },
                      attrs: { id: "information-box-conter" },
                    },
                    [
                      _c("div", { staticClass: "information-box-conter" }, [
                        _vm.isLoading
                          ? _c(
                              "div",
                              { staticClass: "information-box-conter_loading" },
                              [_c("a-spin")],
                              1
                            )
                          : _vm._e(),
                        !_vm.isLoading
                          ? _c("div", [
                              _vm.contentType !== 7
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "information-box-conter_title",
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.currentContent[
                                              _vm.announcementIndex
                                            ].announcementTitle
                                          ) +
                                          " "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm.contentType === 7
                                ? _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        position: "relative",
                                        "margin-bottom": "45px",
                                      },
                                    },
                                    [
                                      _vm.currentContent[_vm.announcementIndex]
                                        .announcementContent.visitLink
                                        ? _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                display: "flex",
                                                "justify-content": "center",
                                              },
                                            },
                                            [
                                              _c(
                                                "a-tooltip",
                                                {
                                                  attrs: {
                                                    placement: "top",
                                                    title:
                                                      "「点击跳转到新页面，查看更多功能信息」",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "a",
                                                    {
                                                      attrs: {
                                                        href: _vm
                                                          .currentContent[
                                                          _vm.announcementIndex
                                                        ].announcementContent
                                                          .visitLink,
                                                        target: "_blank",
                                                      },
                                                    },
                                                    [
                                                      _c("img", {
                                                        attrs: {
                                                          width: "1200px",
                                                          src:
                                                            _vm.currentContent[
                                                              _vm
                                                                .announcementIndex
                                                            ]
                                                              .announcementContent
                                                              .fileList &&
                                                            _vm.currentContent[
                                                              _vm
                                                                .announcementIndex
                                                            ]
                                                              .announcementContent
                                                              .fileList[0]
                                                              .response,
                                                        },
                                                      }),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          )
                                        : _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                display: "flex",
                                                "justify-content": "center",
                                              },
                                            },
                                            [
                                              _c("img", {
                                                attrs: {
                                                  width: "1200px",
                                                  src:
                                                    _vm.currentContent[
                                                      _vm.announcementIndex
                                                    ].announcementContent
                                                      .fileList &&
                                                    _vm.currentContent[
                                                      _vm.announcementIndex
                                                    ].announcementContent
                                                      .fileList[0].response,
                                                },
                                              }),
                                            ]
                                          ),
                                    ]
                                  )
                                : _c("div", [
                                    _vm.currentContent[_vm.announcementIndex]
                                      .announcementContent
                                      ? _c("div", {
                                          directives: [
                                            {
                                              name: "loaded",
                                              rawName: "v-loaded",
                                              value:
                                                _vm.currentContent[
                                                  _vm.announcementIndex
                                                ].announcementContent,
                                              expression:
                                                "\n                  currentContent[announcementIndex].announcementContent\n                ",
                                            },
                                            {
                                              name: "viewer",
                                              rawName: "v-viewer.static",
                                              value: { movable: false },
                                              expression: "{ movable: false }",
                                              modifiers: { static: true },
                                            },
                                          ],
                                          staticStyle: { padding: "0" },
                                        })
                                      : _vm._e(),
                                  ]),
                            ])
                          : _vm._e(),
                      ]),
                      _vm.currentContent[_vm.announcementIndex].enclosureList &&
                      _vm.currentContent[_vm.announcementIndex].enclosureList
                        .length
                        ? _c(
                            "div",
                            {
                              staticClass: "information-box-conter",
                              staticStyle: { "margin-top": "27px" },
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "information-box-conter_title" },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t("common_btn_download_attachment")
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                              _vm._l(
                                _vm.currentContent[_vm.announcementIndex]
                                  .enclosureList,
                                function (item, index) {
                                  return _c(
                                    "div",
                                    {
                                      key: index,
                                      staticClass:
                                        "detail-header-span iconfont-left",
                                    },
                                    [
                                      _c("i", {
                                        staticClass:
                                          "gb-iconfont gb-icon-wendang",
                                      }),
                                      _c(
                                        "span",
                                        {
                                          on: {
                                            click: function ($event) {
                                              return _vm.enclosureClick(
                                                item.enclosureFileUrl,
                                                item.enclosureFileName
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v(_vm._s(item.enclosureFileName))]
                                      ),
                                    ]
                                  )
                                }
                              ),
                            ],
                            2
                          )
                        : _vm._e(),
                    ]
                  )
                : _vm._e(),
            ]),
          ])
        : _vm._e(),
      _vm.contentType !== 7
        ? _c(
            "div",
            { staticClass: "right-anchor-wrapper" },
            [
              _vm.contentSecondLevelTitles[_vm.currentMenu] &&
              _vm.contentSecondLevelTitles[_vm.currentMenu].length
                ? _c("span", {
                    staticClass: "anchor-ball",
                    style: { top: `${_vm.currentBallindex * 30}px` },
                  })
                : _vm._e(),
              _vm.contentSecondLevelTitles[_vm.currentMenu]
                ? _c(
                    "a-anchor",
                    {
                      staticClass: "anchor-information-container",
                      attrs: {
                        affix: false,
                        showInkInFixed: true,
                        getContainer: () => _vm.$refs.information,
                        getCurrentAnchor: () => "#heading_second_0",
                      },
                    },
                    _vm._l(
                      _vm.contentSecondLevelTitles[_vm.currentMenu] || [],
                      function (item, index) {
                        return _c(
                          "a-anchor-link",
                          {
                            key: index,
                            staticClass: "anchor-information-wrapper",
                            nativeOn: {
                              click: function ($event) {
                                return _vm.handleAnchorClick(
                                  $event,
                                  index,
                                  `heading_second_${item.index}`
                                )
                              },
                            },
                          },
                          [
                            _c("template", { slot: "title" }, [
                              _c("span", {
                                domProps: { innerHTML: _vm._s(item.content) },
                              }),
                            ]),
                          ],
                          2
                        )
                      }
                    ),
                    1
                  )
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _c(
        "div",
        {
          staticStyle: {
            position: "absolute",
            bottom: "10px",
            "z-index": "99999",
            width: "100%",
          },
        },
        [
          _c(
            "a-button",
            {
              staticStyle: { height: "32px", "margin-left": "10px" },
              attrs: { type: "primary" },
              on: { click: _vm.informationClick },
            },
            [_vm._v(" " + _vm._s(_vm.$t("common_btn_know_more")) + " ")]
          ),
          _vm.announcementIndex < _vm.currentContent.length - 1
            ? _c(
                "a-button",
                {
                  staticStyle: {
                    position: "absolute",
                    height: "32px",
                    right: "15px",
                  },
                  attrs: { loading: _vm.isLoading },
                  on: { click: _vm.nextClick },
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.$t("common_btn_next_tiao", [
                          _vm.$t("common_home_announcement", []),
                        ])
                      ) +
                      " "
                  ),
                ]
              )
            : _c(
                "a-button",
                {
                  staticStyle: {
                    position: "absolute",
                    height: "32px",
                    right: "15px",
                  },
                  on: { click: _vm.closeClick },
                },
                [_vm._v(" " + _vm._s(_vm.$t("common_btn_i_know")) + " ")]
              ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }